// actions/inventoryActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getInventory = (params) => async (dispatch) => {
  try {
    dispatch({ type: "INVENTORY_REQUEST" });
    const { data } = await api.get("/inventory", { params });
    dispatch({ type: "GET_INVENTORY_SUCCESS", payload: data.items });
  } catch (err) {
    dispatch({ type: "INVENTORY_FAIL", payload: err.response?.data?.message });
  }
};

export const createInventoryItem = (itemData) => async (dispatch) => {
  try {
    dispatch({ type: "INVENTORY_REQUEST" });
    const { data } = await api.post("/inventory", itemData);
    dispatch({ type: "CREATE_INVENTORY_SUCCESS", payload: data.item });
  } catch (err) {
    dispatch({ type: "INVENTORY_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const updateInventoryStock = (itemId, payload) => async (dispatch) => {
  try {
    dispatch({ type: "INVENTORY_REQUEST" });
    await api.patch(`/inventory/${itemId}/stock`, payload);
    dispatch({ type: "UPDATE_INVENTORY_SUCCESS" });
  } catch (err) {
    dispatch({ type: "INVENTORY_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};
